import { store } from '@/store';
import api from '@api/Api';

export default {

    getApp() {
        return api().get('/app').then((response) => {
            store.commit('setUser', response.data.data.user);
            store.commit('setApp', response.data.data.app);
            return response;
        });
    },

}